import React from 'react';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Clausura2016 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 876; i <= 890; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	         kit_path: '/images/kits/todas/',
      kits: [],

      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,

	table2:[{'color':0,'shortname':'sanluis', 'rivalName':'San Luis', 'pj':15, 'pg':3,'pe':7,'pp':5,'gf':22,'gc':25,'dif':-3, 'pts':16},
              {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pj':15, 'pg':3,'pe':7,'pp':5,'gf':16,'gc':19,'dif':-3, 'pts':16},
              {'color':'#295e1e','shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':15, 'pg':6,'pe':5,'pp':4,'gf':31,'gc':26,'dif':5, 'pts':23},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':15, 'pg':8,'pe':1,'pp':6,'gf':22,'gc':24,'dif':-2, 'pts':25},
              {'color':'#135683','shortname':'catolica', 'rivalName':'U. Católica', 'pj':15, 'pg':9,'pe':2,'pp':4,'gf':33,'gc':25,'dif':8, 'pts':29},
              {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':15, 'pg':8,'pe':4,'pp':3,'gf':19,'gc':11,'dif':8, 'pts':28},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':15, 'pg':3,'pe':5,'pp':7,'gf':14,'gc':21,'dif':-7, 'pts':14},
              {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pj':15, 'pg':4,'pe':7,'pp':4,'gf':26,'gc':27,'dif':-1, 'pts':19},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':15, 'pg':3,'pe':7,'pp':5,'gf':29,'gc':25,'dif':4, 'pts':16},
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':15, 'pg':2,'pe':5,'pp':8,'gf':16,'gc':30,'dif':-14, 'pts':11},
              {'color':'#295e1e','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':15, 'pg':4,'pe':7,'pp':4,'gf':23,'gc':22,'dif':1, 'pts':19},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':15, 'pg':2,'pe':9,'pp':4,'gf':20,'gc':24,'dif':-4, 'pts':15},
              {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':15, 'pg':6,'pe':7,'pp':2,'gf':24,'gc':18,'dif':6, 'pts':25},
              {'color':'#295e1e','shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':15, 'pg':8,'pe':4,'pp':3,'gf':28,'gc':24,'dif':4, 'pts':28},
		{'color':0,'shortname':'arica', 'rivalName':'San Marcos', 'pj':15, 'pg':2,'pe':6,'pp':7,'gf':10,'gc':17,'dif':-7, 'pts':12},
              {'color':'#295e1e','shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':15, 'pg':6,'pe':3,'pp':6,'gf':23,'gc':18,'dif':5, 'pts':21}],

        table3:[{'color':0,'shortname':'sanluis', 'rivalName':'San Luis', 'pj':30, 'pg':7,'pe':8,'pp':15,'gf':40,'gc':49,'dif':-9, 'pts':29},
              {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pj':30, 'pg':10,'pe':12,'pp':8,'gf':38,'gc':38,'dif':0, 'pts':42},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':30, 'pg':11,'pe':10,'pp':9,'gf':51,'gc':45,'dif':6, 'pts':43},
              {'color':'#135683','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':30, 'pg':17,'pe':2,'pp':11,'gf':51,'gc':43,'dif':8, 'pts':53},
              {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':30, 'pg':19,'pe':4,'pp':7,'gf':66,'gc':40,'dif':26, 'pts':61},
              {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':30, 'pg':19,'pe':4,'pp':7,'gf':43,'gc':25,'dif':18, 'pts':61},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':30, 'pg':9,'pe':5,'pp':16,'gf':37,'gc':49,'dif':-12, 'pts':32},
              {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pj':30, 'pg':8,'pe':11,'pp':11,'gf':42,'gc':48,'dif':-6, 'pts':35},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':30, 'pg':7,'pe':12,'pp':11,'gf':53,'gc':55,'dif':-2, 'pts':35},
              {'color':'#E42727','shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':30, 'pg':6,'pe':8,'pp':16,'gf':29,'gc':57,'dif':-28, 'pts':26},
              {'color':0,'shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':30, 'pg':8,'pe':11,'pp':11,'gf':43,'gc':50,'dif':-7, 'pts':35},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':30, 'pg':9,'pe':12,'pp':9,'gf':50,'gc':44,'dif':6, 'pts':39},
              {'color':'#135683','shortname':'palestino', 'rivalName':'Palestino', 'pj':30, 'pg':14,'pe':11,'pp':5,'gf':47,'gc':35,'dif':12, 'pts':53},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':30, 'pg':15,'pe':6,'pp':9,'gf':51,'gc':47,'dif':4, 'pts':51},
                {'color':'#E42727','shortname':'arica', 'rivalName':'San Marcos', 'pj':30, 'pg':7,'pe':8,'pp':15,'gf':28,'gc':37,'dif':-9, 'pts':29},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':30, 'pg':8,'pe':8,'pp':14,'gf':34,'gc':41,'dif':-7, 'pts':32}],
    };
  }

  componentDidMount() {
		this.getKits();
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});
		let newtable2 = this.sortTable(this.state.table3);
                this.setState({table3:newtable2});
	}


getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].pg === table[j+1].pg) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].pg === table[j+1].pg) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}



render(){


  let subT = this.subText('#295e1e', 'Clasificado a Liguilla Sudamericana');
  let subC = this.subText('#135683', 'Clasificado a Libertadores 2017');
  let subD = this.subText('#E42727', 'Desciende a Primera B');
let subL = this.subText('#135683', 'Clasificado a Sudamericana 2016');
  return(

	<div style={{textAlign: 'center' }}>

	  <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Clausura 2016</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
	<div style={{ height: '10px' }}></div>
        <div style={{ height: '10px' }}></div>
	{subC}
	{subT}
	
	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Tabla Anual 2015-2016</div>
        <div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table3} />}

        <div style={{ height: '10px' }}></div>
        {subL}
 	{subD}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Clausura 2016</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Clausura 2016</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Clausura 2016" />
     </div>


  )
}

}
export default Clausura2016;
